var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResursiEkspertkinja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6E5DD8;}\n\t.st1{fill:#FA7268;}\n\t.st2{fill:#AA6276;}\n\t.st3{fill:#159497;}\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:#231F20;}\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#FA7267;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.2,95.3c12.7-11.2,33-12.5,47-3.1c14,9.4,20.4,28.7,14.9,44.6c-3.9,11.2-12.7,19.9-19.5,29.6 c-6.8,9.7-11.8,22.5-7,33.3c6.5,14.6,25.8,17.1,39.3,25.7c17,10.8,24.9,32.8,22.1,52.8c-2.8,20-14.7,37.8-29.8,51.2 c-15.1,13.4-33.1,22.9-51.2,31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.8,73.7c-34,0-60.6,19.6-73,32.9s-22.9,28.5-36.3,40.8c-22.5,20.9-51.9,32.5-77.8,49S28.6,237.7,27,268.4 c-0.9,17.9,6.3,35.6,17,49.9c21.2,28.2,56.9,44.7,92.1,42.5s68.6-22.9,86.2-53.5c17.4-30.3,19.8-68.6,42.2-95.3 c10.3-12.2,24.1-21.2,33.3-34.2c12.3-17.4,14.6-41.5,5.9-60.9c-8.8-19.5-28.3-33.7-49.5-36.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.1,
    y: 174.2,
    className: "st0",
    width: 16.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "443.1,369 452.1,353.6 434.2,353.6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 78.9,
    cy: 149.6,
    r: 8.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 265.8,
    cy: 156.1,
    r: 82.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.7,156c-20.7-4-40.8-14.3-58.3-26.5c-5.9,20.9-17.9,38.4-36.2,51.1c-4.2,2.9-8.6,5.6-13.2,8.1 c-4.3-10-6.7-21-6.7-32.6c0-45.5,36.9-82.4,82.4-82.4s82.4,36.9,82.4,82.4c0,0,0,0,0,0C331.4,156.8,314.5,159.2,297.7,156z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.2,412.2c-14.7-37.3-29.7-75.1-54.3-106.8c-16-20.7-36.9-38.7-60.6-49.4c-12.6,10.2-27.8,16.8-44.5,16 c-15.7-0.8-30.9-7.9-42.5-18.8c-26,9.6-49.5,27.7-67.4,49.1c-28.4,33.9-45.3,75.7-61.6,116.8l0,0c42.2,40.6,99.5,65.5,162.7,65.5 c66.3,0,126.2-27.5,168.9-71.7L418.2,412.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M201.7,259.4c0.7,13.8,10.8,26.9,24.1,30.7c14.3,4.1,30.9-2.6,38.3-15.4c7.5,10.1,21.1,15.4,33.4,12.8 c12.3-2.5,22.8-12.7,25.6-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "324.6,421 309.4,407 294.2,421 294.2,351.1 324.6,351.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.1,340.3c0,2.3-4.2,4-4.7,6.2c-0.5,2.2,2.5,5.6,1.6,7.6c-1,2-5.5,1.8-6.9,3.5c-1.4,1.7-0.2,6.1-1.9,7.5 c-1.7,1.4-5.7-0.8-7.7,0.2c-2,1-2.8,5.4-5,5.9c-2.1,0.5-4.8-3.2-7.1-3.2c-2.3,0-4.9,3.7-7.1,3.2c-2.2-0.5-3-5-5-5.9 c-2-1-6,1.2-7.7-0.2c-1.7-1.4-0.5-5.8-1.9-7.5c-1.4-1.7-5.9-1.5-6.9-3.5c-1-2,2.1-5.4,1.6-7.6c-0.5-2.1-4.7-3.9-4.7-6.2 c0-2.3,4.2-4,4.7-6.2c0.5-2.2-2.5-5.6-1.6-7.6c1-2,5.5-1.8,6.9-3.5c1.4-1.7,0.2-6.1,1.9-7.5c1.7-1.4,5.7,0.8,7.7-0.2 c2-1,2.8-5.4,5-5.9c2.1-0.5,4.8,3.2,7.1,3.2c2.3,0,4.9-3.7,7.1-3.2c2.2,0.5,3,5,5,5.9c2,1,6-1.2,7.7,0.2c1.7,1.4,0.5,5.8,1.9,7.5 c1.4,1.7,5.9,1.5,6.9,3.5c1,2-2.1,5.4-1.6,7.6C336.9,336.3,341.1,338.1,341.1,340.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 309.4,
    cy: 340.3,
    r: 17.1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 262.4,
    cy: 172.7,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 299.7,
    cy: 172.7,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M293.1,199.2c-6.3,6.3-16.4,6.3-22.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M92.4,100.8c13,9.5,26.1,19.1,39.1,28.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.3,56.8c13.5,18,27,35.9,40.5,53.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M164.3,45.1c5.6,14,11.2,28,16.8,42"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResursiEkspertkinja);
export default __webpack_public_path__ + "static/media/Resursi-ekspertkinja.ee8d5cdd05881ab93674381491969405.svg";
export { ForwardRef as ReactComponent };